// eslint-disable-next-line func-names
(function($) {
  const App = (() => {
    const $topMenuLinksInitialOrder = $(".js-block-top-links a");
    const $mobileMenu = $("#mobile-menu");
    const $body = $(document.body);
    $body.append($mobileMenu);

    // Base UI Actions
    function bindUiActions() {
      function setMobileMenuTabIndex() {
        const focusableElements =
          'button:not(.trigger), [href], [role="button"], iframe, button, input, select, textarea, [tabindex]:not([tabindex="-1"])';
        $mobileMenu.find(focusableElements).attr("tabindex", "-1");

        const isOnLevel1 = $mobileMenu.hasClass(
          "mobile-menu--dropdown-visible"
        );
        const isOnLevel2 = $mobileMenu.hasClass(
          "mobile-menu--submenu-1-visible"
        );
        const isOnLevel3 = $mobileMenu.hasClass(
          "mobile-menu--submenu-2-visible"
        );

        const $mobileHeaderElements = $mobileMenu.find(
          '.js-close-menu, input[type="text"], input[type="submit"], .button--ui-autocomplete-clear'
        );
        const $mobileExtraFocusableElements = $mobileMenu.find(
          ".weather__toggle, .block-top-links a, .accessibility__toggle, .sitemap__link"
        );

        if ($("body").hasClass("weather-is-open")) {
          $mobileMenu
            .find(".cam__iframe, .current-weather__title__mobile-back")
            .attr("tabindex", "0");
        }

        if (isOnLevel3) {
          const $elementsToEnableFocus = $(
            ".menu--level-2 > .menu-item--submenu-visible"
          ).find("> .js-submenu-back, > .menu--sub > .menu-item > a");
          $elementsToEnableFocus.attr("tabindex", "0");
          $mobileHeaderElements.attr("tabindex", "0");
          return;
        }

        if (isOnLevel2) {
          const $elementsToEnableFocus = $(
            ".menu--level-1 > .menu-item--submenu-visible"
          ).find("> .js-submenu-back, > .menu--sub > .menu-item > a");
          $elementsToEnableFocus.attr("tabindex", "0");
          $mobileHeaderElements.attr("tabindex", "0");
          return;
        }

        if (isOnLevel1) {
          const $elementsToEnableFocus = $(
            ".menu--main > .menu > .menu-item--dropdown-visible"
          ).find(
            ".js-menu-back, .menu__dropdown > .menu--sub > .menu-item > a"
          );
          $elementsToEnableFocus.attr("tabindex", "0");
          $mobileHeaderElements.attr("tabindex", "0");
          return;
        }

        const $elementsToEnableFocus = $(
          ".menu--main > .menu > .menu-item > a"
        );
        $elementsToEnableFocus.attr("tabindex", "0");
        $mobileHeaderElements.attr("tabindex", "0");
        $mobileExtraFocusableElements.attr("tabindex", "0");
      }

      $(document).on("keyup", function(e) {
        // ESC
        if (e.keyCode === 27) {
          $('.modal-wrapper[aria-hidden="false"]').attr("aria-hidden", "true");
        }
      });
      $(".js-open-menu").on("click", e => {
        e.preventDefault();
        $mobileMenu.addClass("mobile-menu--open");
        $(e.target).attr("aria-expanded", true);
        setMobileMenuTabIndex();
        trapMenuFocus(true);

        $(document).on("keydown.mobileMenuClose", function(event) {
          if (event.key === "Escape") {
            closeMobileMenu();
          }
        });
      });

      $(".js-close-menu").on("click", e => {
        e.preventDefault();
        closeMobileMenu();
      });

      function closeMobileMenu() {
        $mobileMenu.removeClass("mobile-menu--open");
        $(".js-open-menu").attr("aria-expanded", null);
        $(".js-open-menu").focus();
        $(document).off("keydown.mobileMenuClose");
      }

      $(".js-toggle-search").on("click", e => {
        e.preventDefault();
        const $body = $("body");

        $body.toggleClass("search-form-open");

        if ($body.hasClass("search-form-open")) {
          $(document).on("keydown.headerSearchFocusTrap", function(event) {
            if (
              event.key === "Tab" &&
              document.activeElement ===
                $('.header .block-search-block input[type="text"]')[0]
            ) {
              if (event.shiftKey) {
                event.preventDefault();
                $(".js-toggle-search").focus();
              }
            }

            if (
              event.key === "Tab" &&
              document.activeElement === $(".js-toggle-search")[0]
            ) {
              if (event.shiftKey) return;
              event.preventDefault();
              $('.header .block-search-block input[type="text"]').focus();
            }
          });
        } else {
          $(document).off("keydown.headerSearchFocusTrap");
        }
      });

      $(".js-toggle-gallery-grid").on("click", e => {
        e.preventDefault();
        $(".gallery")
          .removeClass("list")
          .addClass("albums");
        $(".gallery__view-mode .button").removeClass("is-active");
        $(e.target).addClass("is-active");
      });

      $(".js-toggle-gallery-list").on("click", e => {
        e.preventDefault();
        $(".gallery")
          .removeClass("albums")
          .addClass("list");
        $(".gallery__view-mode .button").removeClass("is-active");
        $(e.target).addClass("is-active");
      });

      $(".js-toggle-services-filters").on("click", e => {
        e.preventDefault();
        $("#services-search-filter-form").toggleClass("form--open");
      });

      $(document).ready(() => {
        if ($(window).outerWidth() < 1280) {
          $(".header, .mobile-menu").css(
            "top",
            $("#toolbar-bar")
              .find(".toolbar-tab")
              .filter(":visible")
              .outerHeight()
          );
          $(".bef--secondary").attr("open", null);
          mobileLayout();
        } else {
          cleanupClasses();
        }
      });

      $(document).on("keydown", e => {
        if (e.key === "Escape") {
          cleanupClasses();
        }
      });

      $(".header__bottom").on("click", function(e) {
        if ($(e.target).is(this)) {
          cleanupClasses();
        }
      });

      const updateHeaderPosition = () => {
        const $layout = $(".layout"),
          $headerBottom = $(".header__bottom"),
          toolbarHeight =
            $("#toolbar-bar")
              .find(".toolbar-tab")
              .filter(":visible")
              .outerHeight() || 0,
          headerTopHeight = $(".header__top").outerHeight() || 0;

        if ($(window).outerWidth() >= 1280) {
          if ($(window).scrollTop() > headerTopHeight) {
            $layout.addClass("layout--header-fixed");
            $headerBottom.css("top", toolbarHeight);
          } else {
            $layout.removeClass("layout--header-fixed");
            $headerBottom.attr("style", null);
          }
        }
      };

      updateHeaderPosition();

      $(window).on("scroll", () => {
        updateHeaderPosition();
        if ($(".node__anchor-links").length) {
          initAnchors();
        }
      });

      const windowResize = debounce(() => {
        // don't perform resize actions if video is fullscreen
        if ($(".cam__iframe").outerWidth() != $(window).outerWidth()) {
          if ($(window).outerWidth() < 1280) {
            $(".header, .mobile-menu").css(
              "top",
              $("#toolbar-bar")
                .find(".toolbar-tab")
                .filter(":visible")
                .outerHeight()
            );
            $(".weather__drop")[0].style.setProperty(
              "--we-weather-drop-offset-top",
              getCalculatedWeatherTopOffset()
            );
            $(".language-switcher-dropdown").removeClass(
              "language-switcher-dropdown--open"
            );
          } else {
            $(".header, .mobile-menu").attr("style", null);
            $(".weather__drop")[0].style.setProperty(
              "--we-weather-drop-offset-top",
              getCalculatedWeatherTopOffset()
            );
            cleanupClasses();
          }

          mobileLayout();
        }
      }, 100);

      function getCalculatedWeatherTopOffset() {
        if ($(window).outerWidth() < 1280) {
          let topOffset = 60;

          const $searchBlock = $(".block-search-block");

          if ($searchBlock.length) {
            topOffset += $searchBlock.outerHeight();
          }

          return `${topOffset}px`;
        } else {
          return `${$(".header__bottom").offset().top}px`;
        }
      }

      $(window).on("resize", windowResize);

      $(window).on("message", e => {
        const data = e.originalEvent.data;
        $(`iframe[src^="${e.originalEvent.origin}"]`).css(
          "height",
          data.height + "px"
        );
      });

      function navigateToLocationHash() {
        if (location.hash) {
          var whash = location.hash.replace(/#/, "");
          var pairs = whash.split("&");
          if (pairs.length === 1) {
            if ($(location.hash).length) {
              const target = location.hash.split("#");
              smoothScrollTo($(`#${decodeURI(target[1])}`));
            }
          }
        }
      }

      $(".ckeditor-accordion").on("ckeditorAccordionAttached", () => {
        navigateToLocationHash();
      });

      // Manages the case where user writes a hash into url manually
      window.addEventListener("popstate", () => {
        const jqueryAccordionAnimationTime = 300;
        setTimeout(navigateToLocationHash, jqueryAccordionAnimationTime);
      });

      $(".js-dropdown-toggle").on("click", e => {
        e.preventDefault();
        const $this = $(e.target);

        if ($this.parent().hasClass("menu-item--dropdown-visible")) {
          $this.parent().removeClass("menu-item--dropdown-visible");
          if ($(window).outerWidth() < 1280) {
            $mobileMenu.removeClass("mobile-menu--dropdown-visible");
          }
          $("body").removeClass("u-submenu-open");
          $this
            .next()
            .find("[data-menu-level]")
            .attr("tabindex", "-1");
          $this.attr("aria-expanded", "false");
        } else {
          $(".menu-item--dropdown-visible").removeClass(
            "menu-item--dropdown-visible"
          );
          $this.parent().addClass("menu-item--dropdown-visible");
          if ($(window).outerWidth() < 1280) {
            $mobileMenu.addClass("mobile-menu--dropdown-visible");
          }
          $("body").addClass("u-submenu-open");
          $this
            .next()
            .find(`[data-menu-level="1"]`)
            .attr("tabindex", "0");
          $this.attr("aria-expanded", "true");
        }
        if ($(window).outerWidth() < 1280) {
          setMobileMenuTabIndex();
          trapMenuFocus();
        }
      });

      $(".js-submenu-toggle").on("click", e => {
        e.preventDefault();
        const $this = $(e.target);
        if ($this.hasClass("js-theme-web")) {
          return;
        }
        const $currentDropdown = $this.closest(".menu__dropdown");
        const nextMenuLevel = parseInt($this.data("menu-level"));

        if ($this.parent().hasClass("menu-item--submenu-visible")) {
          $this.parent().removeClass("menu-item--submenu-visible");
          $this
            .next()
            .find(`[data-menu-level]`)
            .attr("tabindex", "-1");
          $this.attr("aria-expanded", "false");
          setDropdownMenuHeights($currentDropdown);

          if ($(window).outerWidth() < 1280) {
            setMobileMenuTabIndex();
            trapMenuFocus();
          }
        } else {
          const $previousOpenMenu = $this
            .parent()
            .parent()
            .find("> .menu-item--submenu-visible");
          $previousOpenMenu.removeClass("menu-item--submenu-visible");
          const $menuButtons = $previousOpenMenu.find(
            ".js-submenu-back, .menu--sub [data-menu-level]"
          );

          $menuButtons.each(function() {
            if (parseInt($(this).attr("data-menu-level")) > 1) {
              $(this).attr("tabindex", "-1");
            }
          });

          $previousOpenMenu
            .find(".js-toggle-menu")
            .attr("aria-expanded", "false");

          $this.parent().addClass("menu-item--submenu-visible");
          const $nextMenu = $this.next();
          $nextMenu
            .find(`[data-menu-level=${nextMenuLevel + 1}]`)
            .attr("tabindex", "0");

          $nextMenu
            .find(".menu-item--submenu-visible [data-menu-level]")
            .attr("tabindex", "0");
          $nextMenu
            .find(".menu-item--submenu-visible .js-toggle-menu")
            .attr("aria-expanded", "true");

          $this.attr("aria-expanded", "true");

          if ($(window).outerWidth() < 1280) {
            $mobileMenu.addClass(
              `mobile-menu--submenu-${nextMenuLevel}-visible`
            );
            setMobileMenuTabIndex();
            trapMenuFocus();
          } else {
            setDropdownMenuHeights($currentDropdown);
          }
        }
      });

      function setDropdownMenuHeights($currentDropdown) {
        let $allSubMenus = $currentDropdown.find(
          ".menu--sub:not(.menu-item--theme-site .menu--sub)"
        );
        // Reset submenu and dropdown heights
        $currentDropdown.attr("style", null);
        $allSubMenus.each(function() {
          $(this).attr("style", null);
        });
        // Get tallest submenu
        let $rootSubMenu = $currentDropdown.find(".menu--sub:first");
        let subMenuHeight = $rootSubMenu.outerHeight();
        $rootSubMenu
          .find(".menu-item--submenu-visible:first .menu--sub")
          .each(function() {
            let currentSubMenuHeight = $(this).outerHeight();
            if (subMenuHeight < currentSubMenuHeight)
              subMenuHeight = currentSubMenuHeight;
          });
        // Set submenu heights
        $allSubMenus.each(function() {
          $(this).css("height", subMenuHeight);
        });
        $currentDropdown.css("height", subMenuHeight);
      }

      $(".js-menu-back").on("click", e => {
        e.preventDefault();
        const $this = $(e.target);
        $(".menu-item--dropdown-visible").removeClass(
          "menu-item--dropdown-visible"
        );
        $mobileMenu.removeClass("mobile-menu--dropdown-visible");
        $this
          .next()
          .find('[data-menu-level="1"]')
          .attr("tabindex", "-1");

        if ($(window).outerWidth() < 1280) {
          setMobileMenuTabIndex();
          trapMenuFocus();
          setTimeout(
            () =>
              $this
                .parent()
                .parent()
                .find("> .js-dropdown-toggle")
                .focus(),
            100
          );
        }
      });

      $(".js-submenu-back").on("click", e => {
        e.preventDefault();
        const $this = $(e.target);
        const currentMenuLevel = $this.data("menu-level");
        $(".menu-item--submenu-visible").removeClass(
          `menu-item--submenu-${currentMenuLevel}-visible`
        );
        $this.parent().removeClass("menu-item--submenu-visible");
        $mobileMenu.removeClass(
          `mobile-menu--submenu-${currentMenuLevel}-visible`
        );
        $this
          .parent()
          .find(`[data-menu-level=${currentMenuLevel + 1}]`)
          .attr("tabindex", "-1");

        if ($(window).outerWidth() < 1280) {
          setMobileMenuTabIndex();
          trapMenuFocus();
        }
      });

      $(".js-toggle-anchor-list").on("click", e => {
        e.preventDefault();
        $(e.target)
          .parent()
          .toggleClass("node__anchor-links--open");
      });

      $(".js-side-submenu-toggle").on("click", e => {
        e.preventDefault();
        const $this = $(e.target);
        if ($this.parent().hasClass("menu-item--active-trail")) {
          $this.parent().toggleClass("submenu-closed");
        } else {
          $this.parent().toggleClass("submenu-open");
        }
      });

      $("label.option").on("keypress", e => {
        const $this = $(e.target);
        if (e.key === "Enter") {
          $(`#${$this.attr("for")}`).trigger("click");
        }
      });

      initSelect2();

      $("body").on("click keypress", ".messages__close", e => {
        $(e.target)
          .parent()
          .parent()
          .hide();
      });

      $(".node__anchor-links a").on("click", e => {
        e.preventDefault();
        if (
          location.pathname.replace(/^\//, "") ===
            e.target.pathname.replace(/^\//, "") &&
          location.hostname === e.target.hostname
        ) {
          smoothScrollTo($(decodeURI(e.target.hash)));
          window.location.hash = e.target.hash;
          return false;
        }
      });

      if ($(".node__anchor-links").length) {
        initAnchors();
      }

      $("input.form-text").on("input", function(event) {
        const $associatedPlaceholder = $(event.target)
          .parent()
          .find(".form-item__input__placeholder");

        if (event.target.value.length > 0) {
          $associatedPlaceholder.addClass("js-visible");
        } else {
          $associatedPlaceholder.removeClass("js-visible");
        }
      });

      $(".auth__link").on("click", function() {
        setDropdownAttributes($(this));
        $(this)
          .parent()
          .toggleClass("auth--open");

        $(document).on("keydown.handleAuthClose", function(event) {
          if (event.key === "Esc" && $(".auth").hasClass("auth--open")) {
            setDropdownAttributes($(".auth__link"));
            $(document).off("keydown.handleAuthClose");
          }
        });

        if (!$(".auth").hasClass("auth--open")) {
          $(document).off("keydown.handleAuthClose");
        }
      });

      $(".language-switcher-dropdown__button").on("click", function() {
        setDropdownAttributes($(this));
        $(this)
          .parent()
          .toggleClass("language-switcher-dropdown--open");
      });

      const setDropdownAttributes = $dropdown => {
        $dropdown.attr("aria-expanded", function(i, val) {
          return val === "true" ? null : true;
        });
        $dropdown
          .next()
          .find("a")
          .attr("tabindex", function(i, val) {
            return val === "-1" ? "0" : "-1";
          });
      };

      $(document).ajaxStop(() => initSelect2());
    }

    function initSelect2() {
      const $selectElements = $(
        ".form-select:not(.bef-links):not(.shs-enabled)"
      );

      if ($selectElements.length) {
        $selectElements.each((key, item) => {
          if (!item.hasAttribute("tv-skip-minimum-results-for-search")) {
            $(item).select2({
              minimumResultsForSearch: -1
            });
          }
        });
      }
    }

    function initAnchors() {
      const heights = getFixedElementsHeights();
      const $anchorLinks = $(".node__anchor-links");
      const anchorOffset = $anchorLinks.length ? $anchorLinks.offset().top : 0;
      $anchorLinks.css(
        "top",
        heights.adminBarHeight + heights.headerBottomHeight
      );

      if (
        $(window).scrollTop() >=
        anchorOffset - heights.adminBarHeight - heights.headerBottomHeight
      ) {
        $anchorLinks.addClass("is-sticky");
      } else {
        $anchorLinks.removeClass("is-sticky");
      }
    }

    function smoothScrollTo(target) {
      target = target.length ? target : $(`[name=${target.hash.slice(1)}]`);

      if (target.length) {
        const heights = getFixedElementsHeights();
        const offset =
          heights.headerBottomHeight +
          heights.adminBarHeight +
          heights.anchorLinksHeight +
          heights.headerTopHeight;

        $("html,body").animate(
          {
            scrollTop: target.offset().top - offset
          },
          300
        );
      }
    }

    initOpinions();

    function initOpinions() {
      const $opinionImageContainer = $(".opinion--item--image-container");
      $opinionImageContainer.click(function() {
        $(this)
          .parent()
          .find(".opinion--modal--visible")
          .removeClass("opinion--modal--visible");
        $(this)
          .parent()
          .find(".opinion--modal")
          .toggleClass("opinion--modal--visible");
      });
      $opinionImageContainer.mouseenter(function() {
        $(this)
          .parent()
          .find(".opinion--modal")
          .addClass("opinion--modal--visible");
      });
      $opinionImageContainer.mouseleave(function() {
        $(this)
          .parent()
          .find(".opinion--modal")
          .removeClass("opinion--modal--visible");
      });
    }

    function initContentLists() {
      const lists = document.querySelectorAll(
        ".node__content ul",
        ".node__content ol"
      );
      const listItems = document.querySelectorAll(".node__content li");

      lists.forEach(list => {
        if (!list.role) {
          list.role = "list";
        }
      });

      listItems.forEach(item => {
        if (!item.role) {
          item.role = "listitem";
        }
      });
    }

    initContentLists();

    function initContentTables() {
      const tables = document.querySelectorAll(".node__content table");

      tables.forEach(table => {
        const isWrapped = table.closest(".table-wrapper");

        if (!isWrapped) {
          const tableWrapper = document.createElement("div");
          tableWrapper.classList.add("table-wrapper");
          table.parentNode.insertBefore(tableWrapper, table);
          tableWrapper.appendChild(table);
        }
      });
    }

    initContentTables();

    /**
     * Fix for macOS 12 VoiceOver
     */
    function initSkipToContent() {
      const $skipToContentButton = $(".skip-to-content");
      const contentId = $skipToContentButton.attr("href");

      $skipToContentButton.on("focus", function() {
        $(contentId).attr("tabindex", "-1");
      });

      $(contentId).on("blur", function() {
        $(this).attr("tabindex", null);
      });
    }

    initSkipToContent();

    function getFixedElementsHeights() {
      const isDesktop = $(window).outerWidth() >= 1280;
      const headerBottomHeight = isDesktop ? 80 : 60;
      const adminBarHeight = $("body").hasClass("toolbar-fixed")
        ? $("#toolbar-bar")
            .find(".toolbar-tab")
            .filter(":visible")
            .outerHeight()
        : 0;

      const headerTopHeight = isDesktop ? 0 : 45;

      const $anchorLinks = $(".node__anchor-links");

      const anchorLinksHeight =
        isDesktop && $anchorLinks.length ? $anchorLinks.outerHeight() : 0;

      return {
        headerBottomHeight,
        adminBarHeight,
        anchorLinksHeight,
        headerTopHeight
      };
    }

    function trapMenuFocus(setInitialFocus = false) {
      const mobileMenu = document.getElementById("mobile-menu"),
        focusableElements =
          'button:not(.trigger):not(.focus-skip), [href], input, iframe, select, textarea, [tabindex]:not([tabindex="-1"])';

      if (setInitialFocus) {
        const focusableContent = mobileMenu.querySelectorAll(focusableElements);

        setTimeout(() => {
          focusableContent[0].focus();
        }, 100);
      }

      $(document).off("key.trapMenuFocus");

      $(document).on("keydown.trapMenuFocus", e => {
        const isTabPressed = e.key === "Tab" || e.keyCode === 9;

        if (!isTabPressed) {
          return;
        }

        const focusableContent = mobileMenu.querySelectorAll(focusableElements);

        const filteredFocusableContent = $(focusableContent)
          .not("[tabindex='-1']")
          .filter(function() {
            return $(this).css("visibility") !== "hidden";
          });

        const firstFocusableElement = filteredFocusableContent[0];

        let lastFocusableElement =
          filteredFocusableContent[filteredFocusableContent.length - 1];

        if (e.shiftKey) {
          if (document.activeElement === firstFocusableElement) {
            lastFocusableElement.focus();
            e.preventDefault();
          }
        } else {
          if (document.activeElement === lastFocusableElement) {
            firstFocusableElement.focus();
            e.preventDefault();
          }
        }
      });
    }

    /**
     * @param element {HTMLElement}
     */
    function changeBrowserFontSizeMultiplier(element) {
      const baseFontSize = 16;

      const browserFontSizeMultiplier = element.clientHeight / baseFontSize;

      document.documentElement.style.setProperty(
        "--browser-font-size-multiplier",
        browserFontSizeMultiplier.toString()
      );
    }

    function initFontSizer() {
      const fontSizerElement = document.querySelector(".font-sizer");

      if (fontSizerElement) {
        const heightObserver = new ResizeObserver(entries => {
          for (const entry of entries) {
            changeBrowserFontSizeMultiplier(fontSizerElement);
          }
        });

        heightObserver.observe(fontSizerElement);

        changeBrowserFontSizeMultiplier(fontSizerElement);
      }
    }

    initFontSizer();

    function mobileLayout() {
      const $mobileMenuHeader = $(".mobile-menu__header"),
        $mobileMenuBody = $(".mobile-menu__body"),
        $headerTop = $(".header__top"),
        $headerMenuToggle = $(".header__menu-open"),
        $sitemap = $(".block-sitemap"),
        $weather = $(".block-we-weather"),
        $weatherDrop = $(".weather__drop"),
        $homeLink = $(".block-home-link"),
        $homeLinkWrapper = $(".block-sitemap-syndicate__list__item--home-link"),
        $menuMain = $(".block-menu.menu--main, #block-image-catalog"),
        $accessibility = $(".block-we-accessibility"),
        $accessibilityToggleWrapper = $accessibility.find(".accessibility"),
        $accessibilityToggle = $("[data-accessibility-toggle]"),
        $menuToggle = $(".js-open-menu"),
        $search = $("#block-search-block"),
        $auth = $(".block-we-user-block").length
          ? $(".block-we-user-block")
          : $(".auth"),
        $servicesSearch = $(".services-search-query-form"),
        $servicesFilters = $(".services-search-filter-form"),
        $topLinksWrapper = $(".js-block-top-links"),
        $topMobileLinkWrapper = $("#top-mobile-link-wrapper"),
        $languageSwitcher = $(".block-language-switcher");

      if ($(window).outerWidth() < 1280) {
        $($topMenuLinksInitialOrder.get().reverse()).each(function() {
          $topLinksWrapper.append($(this));
        });

        $search.insertAfter($mobileMenuHeader);
        $body.prepend($accessibility);
        $topMobileLinkWrapper.insertAfter($languageSwitcher);
        $mobileMenuBody.append([
          $menuMain,
          $weather,
          $topLinksWrapper,
          $accessibilityToggle,
          $sitemap,
          $homeLink
        ]);
        $weather.append($weatherDrop);
        if ($servicesFilters.length) {
          $servicesFilters.insertAfter($servicesSearch);
        }
        if ($auth.length) {
          if ($sitemap.length) {
            $sitemap.append($auth);
          } else {
            $auth.insertAfter($homeLink);
          }
        }
      } else {
        $topMenuLinksInitialOrder.each(function() {
          $topLinksWrapper.append($(this));
        });

        $headerTop.append($languageSwitcher);
        $headerTop.prepend($accessibility);
        $accessibilityToggleWrapper.prepend($accessibilityToggle);
        $homeLinkWrapper.prepend($homeLink);
        $sitemap.insertAfter($accessibility);
        $weather.insertAfter($sitemap);
        $body.append($weatherDrop);
        $topLinksWrapper.insertAfter($topMobileLinkWrapper);
        if ($auth.length) {
          $auth.insertBefore($headerMenuToggle);
          $menuMain.insertBefore($auth);
          $search.insertAfter($auth);
        } else {
          $menuMain.insertBefore($menuToggle);
          $search.insertAfter($menuMain);
        }
        if ($servicesSearch.length) {
          $(".sidebar").append($servicesFilters);
        }
      }
    }

    function isAndroidTextInputFocus() {
      const userAgent = navigator.userAgent.toLowerCase();
      const isAndroid = userAgent.indexOf("android") !== -1;

      return (
        isAndroid &&
        ($("input[type=search], input[type=text]").is(":focus") ||
          $("textarea").is(":focus"))
      );
    }

    function debounce(func, wait, immediate) {
      let timeout;
      return () => {
        const context = this,
          args = arguments;
        const later = () => {
          timeout = null;
          if (!immediate) {
            func.apply(context, args);
          }
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
          func.apply(context, args);
        }
      };
    }

    function initNestedBefLinks() {
      const $collapsibleRoots = $(".bef-nested-elements");

      $collapsibleRoots.each(function() {
        $(this)
          .find(".bef-nested-elements__group__toggle")
          .on("click", function() {
            $(this).toggleClass("open");
            $(this)
              .closest(".bef-nested-elements__group__child")
              .find("> .bef-nested-elements__group")
              .toggleClass("visually-hidden");
          });
      });
    }

    /**
     * @param {boolean} state
     * @param {string[]} selectorsToIgnore
     */
    function setBodyElementsInert(state, selectorsToIgnore = []) {
      if (selectorsToIgnore.length === 0) {
        for (let element of document.body.children) {
          element.inert = state;
        }
      }

      for (let element of document.body.children) {
        let canIgnore = false;
        for (let selector of selectorsToIgnore) {
          if (selector.startsWith(".")) {
            if (
              element.classList.contains(selector.substring(1, selector.length))
            ) {
              canIgnore = true;
              break;
            }
          } else if (selector.startsWith("#")) {
            if (element.id === selector.substring(1, selector.length)) {
              canIgnore = true;
              break;
            }
          } else if (selector.startsWith("[")) {
            const selectorWithoutContainerLetters = selector.substring(
              1,
              selector.length - 1
            );
            if (selector.includes("=")) {
              // Select everything until the first occurance on "="
              const attributeNameRegex = /(.*)(?==)/;

              // Select everything between `" "` or `' '`;
              const attributeValueRegex = /"(.*)"|'(.*)'/;

              const selectorAttribute = selectorWithoutContainerLetters.match(
                attributeNameRegex
              );
              const selectorValue = selectorWithoutContainerLetters.match(
                attributeValueRegex
              );

              if (selectorAttribute && selectorValue) {
                if (
                  element.hasAttribute(selectorAttribute[0]) &&
                  element.getAttribute(selectorAttribute[0]) ===
                    selectorValue[0].substring(1, selectorValue[0].length - 1)
                ) {
                  canIgnore = true;
                  break;
                }
              }
            } else {
              if (element.hasAttribute(selectorWithoutContainerLetters)) {
                canIgnore = true;
                break;
              }
            }
          }
        }

        if (!canIgnore) element.inert = state;
      }
    }

    initNestedBefLinks();

    function initCookiePolicyModifications() {
      $("body").on("eu_cookie_compliance_popup_open", function() {
        const $cookieAcceptButton = $(
          ".eu-cookie-compliance-banner .agree-button"
        );
        if (!$cookieAcceptButton.length) return;
        setBodyElementsInert(true, ["#sliding-popup"]);
        $cookieAcceptButton.focus();
      });

      $("body").on("eu_cookie_compliance_popup_close", function() {
        setBodyElementsInert(false, ["#sliding-popup"]);
      });
    }

    initCookiePolicyModifications();

    function cleanupClasses() {
      const mobileMenuClasses = [
        "mobile-menu--open",
        "menu--dropdown-visible",
        "mobile-menu--submenu-1-visible",
        "mobile-menu--submenu-2-visible",
        "mobile-menu--submenu-3-visible",
        "mobile-menu--dropdown-visible"
      ];
      const menuItemClasses = [
        "menu-item--dropdown-visible",
        "menu-item--submenu-visible"
      ];
      $mobileMenu.removeClass(mobileMenuClasses);
      $(".menu-item").removeClass(menuItemClasses);
      $("body").removeClass("u-submenu-open search-form-open");
      $(".block-image-catalog-filters .bef--secondary").attr("open", true);
      $("[data-menu-level]:not([data-menu-level=0])").attr("tabindex", "-1");
      $(".js-toggle-search").attr("tabindex", "0");
      $(".auth").removeClass("auth--open");
      $(".auth__link").attr("tabindex", "0");
      $(".links .language-link").attr("tabindex", "0");
      $(".language-switcher-dropdown").removeClass(
        "language-switcher-dropdown--open"
      );
    }

    return {
      init: () => {
        bindUiActions();
      }
    };
  })();

  App.init();
})(jQuery);
